<template>
  <SettingsField :label="$t('platform.disable_show_ads')" :hint="$t('platform.card.fields.disabled_categories')" :error="allSelected ? $t('platform.enable_category_error') : ''">
    <custom-multiselect :value="value" :list="categories" :class="{ invalid: allSelected }" :allowEmpty="true" :multiply="true" :searchBy="nameKey" @input="$emit('input', $event)">
      <template v-slot:block="props">
        <span>{{ props.value[nameKey] }}</span>
      </template>
      <template v-slot:list="props">
        <span>{{ props.value[nameKey] }}</span>
      </template>
    </custom-multiselect>
  </SettingsField>
</template>
<script>
import SettingsField from "@/components/PlatformCard/SettingsField.vue";
import { ALL_CATEGORIES, allCategoriesDisabled } from "@/components/PlatformCard/subaccountPayload";

// Every category picked turns into "All", which may not be saved: a platform has to show at least one.
export default {
  name: "DisabledCategoriesField",
  components: { SettingsField },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    nameKey() {
      return `name_${this.$i18n.locale === "ru" ? "ru" : "en"}`;
    },
    allSelected() {
      return allCategoriesDisabled(this.value);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(selected) {
        if (selected && this.categories.length > 0 && selected.length === this.categories.length) {
          this.$emit("input", [ALL_CATEGORIES]);
        }
      },
    },
  },
};
</script>
